import { Pipe, PipeTransform } from '@angular/core';
import { PackageServicesService } from '../dashboard/marketing/promotions/components/packages/package-form/packageServices.service';
import { SharedService } from 'src/app/services/other/shared.service';

@Pipe({
  name: 'sumByKey',
})
export class SumByKeyPipe implements PipeTransform {
  constructor(
    private _packageService: PackageServicesService,
    private sharedService: SharedService) {}
  transform(items: any[], key: string): number {
    if (!items || !key) {
      return 0; // Return 0 if no items or key is provided
    }

    let sum = 0;
    items.forEach((item) => {
      if (item[key]) {
        sum += +item[key];
      }
    });
    const fixedNumber = Number(sum) > 0 ? Number(sum.toFixed(this.sharedService.GetFractionRoundCount)) : 0;
    console.log(fixedNumber);
    return fixedNumber;
  }
}
